module.exports = __webpack_public_path__ + "static/media/California New Car Dealers Association Logo.43455060.jpeg";